const formClassName = (type, touched, skipTouchedValidation, error, disabled, warning) => {
  let formErrorClass = 'form-group row';
  let validationFeedback = 'form-control';
  if (type === 'hidden') {
    formErrorClass += ' hide';
  }
  if ((touched || skipTouchedValidation) && error && !disabled) {
    validationFeedback += ' is-invalid';
  } else if (touched && warning) {
    validationFeedback += ' is-invalid is-invalid-warn';
  } else if (touched && !disabled) {
    validationFeedback += ' is-valid';
  }
  return { formErrorClass, validationFeedback };
};

export default formClassName;
